var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"nav__link",domProps:{"innerHTML":_vm._s(_vm.title)},on:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }